export default "__VITE_ASSET__CVVlnGFO__"